import Popup from "../Popup";
import Button from "../../UI/Button";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";

export function RateTechnicianModal ({showModal, setShowModal}) {
  const Jobs = useGetJobs();
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const [professionalism, setProfessionalism] = useState(0);
  const [reliability, setReliability] = useState(0);
  const [quality, setQuality] = useState(0);
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    const rateResult = {professionalism, reliability, comment};
    Jobs.rate({
      params: activeJob?.id,
      body: rateResult
    });
    closeModal();
  }
  const closeModal = () => {
    setShowModal(false);
    setProfessionalism(0);
    setReliability(0);
    setQuality(0);
    setComment('');
  }

  useEffect(() => {
    if (showModal && activeJob) {
      setProfessionalism(activeJob.professionalism || 0);
      setReliability(activeJob.reliability || 0);
      setQuality(activeJob.quality || 0);
      setComment('');
    }
  }, [showModal, activeJob]);

  return (
    <>
      {showModal && (
        <Popup
          title='Rate job quality'
          closePopup={closeModal}
          isOpen={showModal}
        >
          <div className="technician__popup">
            <div className="technician__popup-info">
              <div className='technician__popup-left'>
                <div className="technician__popup-avatar">
                  <img src="/assets/images/avatar-placeholder.png" alt=""/>
                </div>
                <div>
                  <p className="technician__popup-name">{activeJob?.technician?.name}</p>
                  <p className="technician__popup-id">Tech ID: {activeJob?.technician?.id}</p>
                </div>
              </div>
              {
                activeJob?.technician?.technician_rating && (
                  <div className='technician__popup-right'>
                      <span>
                        <img src="/assets/icons/star-rate.svg" alt="star"/>
                      </span>
                    <p>{activeJob?.technician?.technician_rating}</p>
                  </div>
                )
              }
            </div>
            <div className="technician__popup-rateItem">
              <p>Professionalism</p>
              <div className="technician__popup-stars">
                  <span onClick={() => {setProfessionalism(1)}}>
                    <img src={`${professionalism === 1 || professionalism === 2 || professionalism === 3 || professionalism === 4 || professionalism === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setProfessionalism(2)}}>
                    <img src={`${professionalism === 2 || professionalism === 3 || professionalism === 4 || professionalism === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setProfessionalism(3)}}>
                    <img src={`${professionalism === 3 || professionalism === 4 || professionalism === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setProfessionalism(4)}}>
                    <img src={`${professionalism === 4 || professionalism === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setProfessionalism(5)}}>
                    <img src={`${professionalism === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
              </div>
            </div>
            <div className="technician__popup-rateItem">
              <p>Reliability</p>
              <div className="technician__popup-stars">
                  <span onClick={() => {setReliability(1)}}>
                    <img src={`${reliability === 1 || reliability === 2 || reliability === 3 || reliability === 4 || reliability === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setReliability(2)}}>
                    <img src={`${reliability === 2 || reliability === 3 || reliability === 4 || reliability === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setReliability(3)}}>
                    <img src={`${reliability === 3 || reliability === 4 || reliability === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setReliability(4)}}>
                    <img src={`${reliability === 4 || reliability === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
                <span onClick={() => {setReliability(5)}}>
                    <img src={`${reliability === 5 ? '/assets/icons/big-star-active.svg' : '/assets/icons/big-star.svg'}`} alt="star"/>
                  </span>
              </div>
            </div>
            <div className="technician__popup-comment">
              <textarea onChange={(e) => {setComment(e.target.value)}} placeholder='Comment'></textarea>
            </div>
            <div className="technician__popup-btns">
              <div className="technician__popup-btn technician__popup-btn_cancel">
                <Button
                  text='Cancel'
                  onClick={closeModal}
                />
              </div>
              <div className="technician__popup-btn">
                <Button
                  text='Submit'
                  onClick={handleSubmit}
                  disabled={reliability === 0 || professionalism === 0}
                />
              </div>
            </div>
          </div>
        </Popup>
      )}
    </>
  )
}
